import API from '../../services/api.svelte.js';
import { notificate } from '../../services/notification.js';

function filterIsEmpy(filter){
    for (let prop in filter) {
        if (filter.hasOwnProperty(prop)) {
            return false;
        }
    }
    return true;
}

export async function getReport(config = {filter: {}}, summary_id) {

    let filter_query_string = '';
    if(!filterIsEmpy(config.filter)){
        Object.keys(config.filter).forEach((k)=>{
            filter_query_string = filter_query_string + (filter_query_string == '' ? "?" : '&') + (k.includes("tag") ? k + "_id" : k) + "=" + config.filter[k];
        });
    }
    if(!summary_id){
        return API.getFile('v2/report' + filter_query_string);
    }
    else {
        return API.getFile('v2/report' + filter_query_string + '&summary_id=' + summary_id);
    }

}

export async function search(){
    return API.get("v2/report/list", {});
}

export async function saveReport(config, summary_id){
    let filter_query_string = '';
    if(!filterIsEmpy(config.filter)){
        Object.keys(config.filter).forEach((k)=>{
            if(!summary_id){
                filter_query_string = filter_query_string + (filter_query_string == '' ? "?" : '&') + (k.includes("tag") ? k + "_id" : k) + "=" + config.filter[k];
            }
            else {
                filter_query_string = filter_query_string + '&'  + (k.includes("tag") ? k + "_id" : k) + '=' + config.filter[k];
            }
        });
    }
    if(!summary_id){
        return API.saveFile('v2/report' + filter_query_string);
    }
    else {
        return API.saveFile('v2/report?' + 'summary_id=' + summary_id + filter_query_string);
    }
}


export function del(id, config = {}) {
    return API.deleteOneResource('v2/report', id, config)
        .then(async (response) => {
            if(!response.ok){
                let toastConfig = {
                    data: "Activo",
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                // api validation errors
                notificate('delete_error', "toast", toastConfig);
                throw await response.json();
            }
            else {
                return true;
            }
        })
    ;
}



export function patch(data, files = [], config = {}) {
    return API.save('v2/report', data, files, config, false)
        .then(async (response) => {
            if (!response.ok) {
                //let errors = await response.json();
                let toastConfig = {
                    data: "Reporte",
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                if(config && config.massive_addition) toastConfig.error = errors;
                notificate('save_error', "toast", toastConfig);
                throw errors;
            }
            else{
                notificate('save_ok', "toast", {data: "Reporte"});
                return response;
            }
        })
    ;
}

export function downloadSavedReport(id){
    return API.getFile(`v2/report/${id}/content`)
}


export async function getJSONreport(config = {}) {
    return API.getFile('export/fast');
}


export default {
    getReport,
    getJSONreport,
    saveReport,
    search,
    del,
    patch,
    downloadSavedReport
}